import Vue from 'vue';
import Router from 'vue-router';
import CreateAccount from '@/views/CreateAccount.vue';
import UserManagement from '@/views/UserManagement.vue';
import Dashboard from '@/views/Dashboard.vue';
import Forbidden from '@/views/Forbidden.vue';
import Home from '@/views/Home.vue';
import MyProfile from '@/views/MyProfile.vue';
import AdminUser from '@/views/AdminUser.vue';
import PasswordReset from '@/views/PasswordReset.vue';
// eslint-disable-next-line import/no-cycle
import store from '@/store/store';

const Notification = () => import('@/views/Notification.vue');
const LandownerReport = () => import('@/views/LandownerReport.vue');
const OriginalLandownerReport = () => import('@/views/OriginalLandownerReport.vue');

Vue.use(Router);

const routeNames = {
  createAccount: 'createAccount',
  forbidden: 'forbidden',
  home: 'home',
  myProfile: 'myProfile',
  passwordReset: 'passwordReset',
  userManagement: 'userManagement',
  createUser: 'createUser',
  editUser: 'editUser',
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: routeNames.home,
      component: Home,
    },
    {
      path: '/createAccount',
      name: routeNames.createAccount,
      component: CreateAccount,
    },
    {
      path: '/userManagement',
      name: 'userManagement',
      component: UserManagement,
    },
    {
      path: '/userManagement/:id/edit',
      name: 'editUser',
      component: AdminUser,
      props: () => ({ edit: true }),
    },
    {
      path: '/userManagement/:type/create',
      name: 'createUser',
      component: AdminUser,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/account/passwordReset',
      name: routeNames.passwordReset,
      component: PasswordReset,
    },
    {
      path: '/myprofile',
      name: routeNames.myProfile,
      component: MyProfile,
    },
    {
      path: '/notification/new',
      name: 'newNotification',
      component: Notification,
    },
    {
      path: '/notification/:id',
      name: 'notification',
      component: Notification,
    },
    {
      path: '/landownerReport/:id/original',
      name: 'originalLandownerReport',
      component: OriginalLandownerReport,
    },
    {
      path: '/landownerReport/:id',
      name: 'landownerReport',
      component: LandownerReport,
    },
    {
      path: '/forbidden',
      name: routeNames.forbidden,
      component: Forbidden,
      props: route => ({ reason: route.query.reason }),
    },
  ],
});

const anonymousRoutes = [
  routeNames.home,
  routeNames.createAccount,
  routeNames.passwordReset,
  routeNames.forbidden,
];

const adminRoutes = [
  routeNames.userManagement,
  routeNames.createUser,
  routeNames.editUser,
];

const profileRoutes = [
  routeNames.myProfile,
];

const anonymousOnlyRoutes = [routeNames.createAccount];
router.beforeEach((to, from, next) => {
  const evaluateRoute = () => {
    const authRequired = !anonymousRoutes.includes(to.name) && !store.state.User.signedIn;
    const anonymousRequired = anonymousOnlyRoutes.includes(to.name) && store.state.User.signedIn;
    const adminRequired = adminRoutes.includes(to.name) && !store.getters['User/mfsAdmin'];
    const profileViewerRequired = profileRoutes.includes(to.name) && !store.getters['User/publicUser'];
    if (authRequired) {
      next(`/?returnUrl=${to.fullPath}`);
    } else if (anonymousRequired || adminRequired || profileViewerRequired) {
      // Redirect to root if route requires anon or admin access.
      next('/');
    } else {
      next();
    }
  };
  // Wait for User store to finish loading before evaluating route
  if (store.state.User.loading) {
    store.watch(
      state => state.User.loading,
      (value) => { if (!value) evaluateRoute(); },
    );
  } else {
    evaluateRoute();
  }
});

export default router;
